/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectItemSampleCommand } from '../../models/delete-project-item-sample-command';
import { DeleteProjectItemSampleCommandResult } from '../../models/delete-project-item-sample-command-result';

export interface ApiProjectItemSamplesDeleteProjectItemSampleDelete$Params {
  
    /**
     * The command to delete a project item Sample.
     */
    body?: DeleteProjectItemSampleCommand
}

export function apiProjectItemSamplesDeleteProjectItemSampleDelete(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesDeleteProjectItemSampleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesDeleteProjectItemSampleDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesDeleteProjectItemSampleDelete.PATH = '/api/ProjectItemSamples/DeleteProjectItemSample';
